export const runnerRouteEn = {
  mapPlaceholder: 'Map unavailable — use Navigate to open the route',
  mapFullscreen: 'Fullscreen',
  mapExitFullscreen: 'Exit',
  routeUnlockTitle: 'Confirm identity',
  routeUnlockReason: 'Confirm your identity to continue navigating the route',
  routeUnlockBody: 'The screen was turned off. Authenticate to resume route navigation.',
  routeUnlockPassword: 'Password',
  routeUnlockSubmit: 'Unlock',
  routeUnlockBiometric: 'Use biometrics',
  routeUnlockError: 'Could not verify identity. Try again.',
  openInMaps: 'Navigate',
  navInApp: 'In-app navigation',
  navExternal: 'External maps',
  navModeRemember: 'Your choice is remembered on this device.',
  navOfflineCached: 'No network — using cached route',
  navReroute: 'Re-route',
  mapPackDownload: 'Download Havana map',
  mapPackReady: 'Havana offline pack ready',
  mapPackDownloading: 'Downloading',
  mapPackUnavailable: 'Offline pack not configured',
  confirmCollected: 'Confirm collected',
  adjustAmount: 'Adjust amount',
  expectedAmount: 'Expected',
  collectedAmountLabel: 'Collected',
  confirmExpected: 'Confirm expected amount',
  saveCollected: 'Confirm amount',
  awaitingLister: 'Awaiting lister confirmation',
  awaitingClear: 'Awaiting clear',
  stopCleared: 'Cleared',
  stopSkipped: 'Skipped',
  stopPending: 'Pending',
  stopInProgress: 'In progress',
  reportIncident: 'Report incident',
  incidentPlaceholder: 'What happened at this stop?',
  incidentSent: 'Incident reported',
  amountAdjustedTitle: 'Collection amount adjusted',
  amountAdjustedBody: '{name}: expected {expected}, collected {collected}',
  mustConfirmBeforeNext: 'Confirm how much you collected before the next stop',
  handoffTitle: 'Confirm delivery',
  handoffHint: 'Confirm the amount you handed to the runner',
  handoffHintSelfCollect: 'The banker is collecting today. No delivery confirm needed — wait for collected & secured.',
  handoffEmpty: 'No stops for you on today’s route.',
  handoffSelfCollectWaiting: 'Waiting for the banker to collect & secure',
  handoffSelfCollectDone: 'Collected & secured by banker',
  handoffSkippedBody: 'This stop was skipped',
  confirmDelivery: 'Confirm delivery',
  deliveryConfirmed: 'Delivery confirmed',
  bankerRouteTitle: 'Route stops',
  routeDepartStatus: 'Departure',
  routeDepartStatusPending: 'Waiting for banker authorization',
  routeDepartStatusAuthorized: 'Authorized to collect',
  routeDepartAuthorize: 'Authorize departure',
  routeDepartAuthorized: 'Departure authorized',
  routeDepartAuthorizedBody: 'Runner was notified to collect ASAP (even if the app is closed).',
  routeDepartRunnerPushTitle: 'Departure authorized — collect now',
  routeDepartRunnerPushBody: 'Your collection route is released. Open it and execute ASAP.',
  routeDepartAuthorizeFailed: 'Could not authorize departure.',
  routeDepartBlockedInProgress: 'Previous departure is still in progress. Finish collecting before authorizing again.',
  routeDepartNothingToCollect: 'Nothing left to collect on this route.',
  routeDepartInsufficientStops: 'Add at least one more stop besides the house address before starting the route.',
  routeDepartStatusNeedStops: 'Waiting for another stop',
  routeCollectionCompleted: 'Collection completed',
  routeCompleteManual: 'Mark completed (exceptional)',
  routeCompleteManualBody: 'Route marked completed manually. You can authorize a new departure when ready.',
  routeCompleteFailed: 'Could not mark the route as completed.',
  routeCompleteNeedsConfirm: 'Confirm before marking the route completed.',
  routeCompleteConfirmTitle: 'Force-complete route?',
  routeCompleteConfirmBody: 'Exceptional action. Use only if the collection cannot finish normally. Pending stops stay as-is; this unlocks a new authorization and is fully audited.',
  routeCompleteConfirmHint: 'A clear reason is required (min. 3 characters). The event is written to the audit log.',
  routeCompleteReasonLabel: 'Reason (required)',
  routeCompleteReasonPlaceholder: 'Why force-complete this collection?',
  routeCompleteReasonRequired: 'Enter a reason before confirming.',
  routeCompleteConfirmAction: 'Confirm force-complete',
  routeDepartWaiting: 'Waiting for departure authorization before confirming amounts.',
  runnerMaxLoadAmount: 'Runner max load',
  runnerMaxLoadHint: 'Maximum cash a runner may carry when combining several house routes in one run (default 1,000,000).',
  runnerMultiRouteTitle: 'Authorized routes',
  runnerMultiRouteHint: 'One route per house. Run separately, or as one trip when under the load cap.',
  runnerRunSeparate: 'Separate',
  runnerRunMerged: 'Single run',
  runnerMergeOverCapacity: 'Total to collect ({total}) exceeds the runner max load ({max}). Run separately.',
  runnerMergedActive: 'Running {count} house routes as one trip · {total}',
  skipStop: 'Skip stop',
  skipReason: 'Reason',
  skipReasonPlaceholder: 'Why skip this stop? (e.g. lister unavailable)',
  skipRequest: 'Request skip',
  skipRequestSent: 'Skip requested',
  skipRequestSentBody: '{name}: waiting for banker approval.',
  skipRequestWaiting: 'Skip waiting for banker approval',
  skipRequestFailed: 'Could not request skip.',
  skipRequestNeedsOnline: 'Skip requests require a network connection.',
  skipRequestPending: 'Skip requested by runner',
  skipApprove: 'Approve skip',
  skipReject: 'Reject skip',
  skipApproved: 'Skip approved',
  skipRejected: 'Skip rejected',
  skipReviewFailed: 'Could not review skip request.',
  skipStopFailed: 'Could not skip stop.',
  skipBankerAppliedBody: '{name} skipped. Runner was notified and the route was recalculated.',
  routeSelfCollectHint: 'No runners available — start the route when ready, navigate like a runner, and mark each stop as collected & secured.',
  routeSelfCollectLabel: 'Banker (self-collect)',
  routeSelfCollectAssignedBody: 'Route ready for self-collect. Start when you want to begin the round.',
  routeDepartAuthorizedSelfCollectBody: 'Route started. Navigate stops and mark each as collected & secured as you pick up.',
  routeSelfCollectStart: 'Start route',
  routeSelfCollectStarted: 'Route started',
  routeSelfCollectStatusLabel: 'Collection',
  routeSelfCollectStatusReady: 'Ready when you are',
  routeSelfCollectStatusLive: 'Collecting — navigate & secure',
  routeSelfCollectStartHint: 'No runner needed. Start when convenient; you can open the map and navigate like a runner.',
  routeSelfCollectLiveHint: 'Route is live. Use the map to navigate; keep the screen on during navigation.',
  routeSelfCollectAutoSkipHint: 'When you start, official stops with nothing to collect are skipped automatically.',
  routeSelfCollectNavHint: 'In-app navigation keeps the screen awake. Turn-by-turn on a locked screen needs External maps (Google/Apple).',
  secureCollect: 'Collected & secured',
  secureCollectDone: 'Collected & secured',
  secureCollectFailed: 'Could not mark stop as collected & secured.',
  editStop: 'Edit stop',
  saveStop: 'Save',
  saveStopFailed: 'Could not save stop changes.',
  stopAddr: 'Address',
  discrepancy: 'Amount mismatch',
  discrepancyDetail: 'Runner {runner} · Lister {lister}',
  discrepancyReviewed: 'Discrepancy reviewed',
  discrepancyMarkReviewed: 'Mark reviewed',
  discrepancyReviewFailed: 'Could not mark discrepancy as reviewed.',
  tabRoute: 'Route',
  tabHandoff: 'Handoff',
} as const;

export const runnerRouteEs = {
  mapPlaceholder: 'Mapa no disponible — usa Navegar para abrir la ruta',
  mapFullscreen: 'Pantalla completa',
  mapExitFullscreen: 'Salir',
  routeUnlockTitle: 'Confirmar identidad',
  routeUnlockReason: 'Confirma tu identidad para seguir navegando la ruta',
  routeUnlockBody: 'Se apagó la pantalla. Autentícate para reanudar la navegación de la ruta.',
  routeUnlockPassword: 'Contraseña',
  routeUnlockSubmit: 'Desbloquear',
  routeUnlockBiometric: 'Usar biometría',
  routeUnlockError: 'No se pudo verificar la identidad. Inténtalo de nuevo.',
  openInMaps: 'Navegar',
  navInApp: 'Navegación in-app',
  navExternal: 'Mapa externo',
  navModeRemember: 'Tu elección se recuerda en este dispositivo.',
  navOfflineCached: 'Sin red — ruta cacheada',
  navReroute: 'Recalcular',
  mapPackDownload: 'Descargar mapa Habana',
  mapPackReady: 'Pack Habana listo',
  mapPackDownloading: 'Descargando',
  mapPackUnavailable: 'Pack offline no configurado',
  confirmCollected: 'Confirmar recogido',
  adjustAmount: 'Ajustar monto',
  expectedAmount: 'Esperado',
  collectedAmountLabel: 'Recogido',
  confirmExpected: 'Confirmar monto esperado',
  saveCollected: 'Confirmar monto',
  awaitingLister: 'Esperando confirmación del listador',
  awaitingClear: 'Pendiente de cierre',
  stopCleared: 'Cerrada',
  stopSkipped: 'Saltada',
  stopPending: 'Pendiente',
  stopInProgress: 'En curso',
  reportIncident: 'Reportar incidencia',
  incidentPlaceholder: '¿Qué ocurrió en esta parada?',
  incidentSent: 'Incidencia reportada',
  amountAdjustedTitle: 'Monto de cobro ajustado',
  amountAdjustedBody: '{name}: esperado {expected}, recogido {collected}',
  mustConfirmBeforeNext: 'Confirma cuánto recogiste antes de la siguiente parada',
  handoffTitle: 'Confirmar entrega',
  handoffHint: 'Confirma el monto que entregaste al runner',
  handoffHintSelfCollect: 'Hoy recoge el banker. No hace falta confirmar entrega — espera recogido y asegurado.',
  handoffEmpty: 'No tienes paradas en la ruta de hoy.',
  handoffSelfCollectWaiting: 'Esperando que el banker recoja y asegure',
  handoffSelfCollectDone: 'Recogido y asegurado por el banker',
  handoffSkippedBody: 'Esta parada fue saltada',
  confirmDelivery: 'Confirmar entrega',
  deliveryConfirmed: 'Entrega confirmada',
  bankerRouteTitle: 'Paradas de ruta',
  routeDepartStatus: 'Salida',
  routeDepartStatusPending: 'Esperando autorización del banker',
  routeDepartStatusAuthorized: 'Autorizado a recoger',
  routeDepartAuthorize: 'Autorizar salida',
  routeDepartAuthorized: 'Salida autorizada',
  routeDepartAuthorizedBody: 'Se avisó al runner para cobrar ya (aunque tenga la app cerrada).',
  routeDepartRunnerPushTitle: 'Salida autorizada — cobra ya',
  routeDepartRunnerPushBody: 'Tu ruta de cobro está liberada. Ábrela y ejecútala lo antes posible.',
  routeDepartAuthorizeFailed: 'No se pudo autorizar la salida.',
  routeDepartBlockedInProgress: 'La salida anterior sigue en curso. Termina el cobro antes de autorizar otra.',
  routeDepartNothingToCollect: 'No queda nada por recoger en esta ruta.',
  routeDepartInsufficientStops: 'Agrega al menos una parada más además de la dirección de la casa antes de iniciar la ruta.',
  routeDepartStatusNeedStops: 'Falta otra parada',
  routeCollectionCompleted: 'Cobro completado',
  routeCompleteManual: 'Marcar completada (excepcional)',
  routeCompleteManualBody: 'Ruta marcada como completada manualmente. Puedes autorizar una nueva salida cuando quieras.',
  routeCompleteFailed: 'No se pudo marcar la ruta como completada.',
  routeCompleteNeedsConfirm: 'Confirma antes de marcar la ruta como completada.',
  routeCompleteConfirmTitle: '¿Forzar cobro completado?',
  routeCompleteConfirmBody: 'Acción excepcional. Úsala solo si el cobro no puede cerrarse con normalidad. Las paradas pendientes quedan como están; se desbloquea una nueva autorización y queda auditado.',
  routeCompleteConfirmHint: 'El motivo es obligatorio (mín. 3 caracteres). El evento se escribe en el log de auditoría.',
  routeCompleteReasonLabel: 'Motivo (obligatorio)',
  routeCompleteReasonPlaceholder: '¿Por qué fuerzas el cierre de este cobro?',
  routeCompleteReasonRequired: 'Escribe un motivo antes de confirmar.',
  routeCompleteConfirmAction: 'Confirmar cierre forzado',
  routeDepartWaiting: 'Esperando autorización de salida antes de confirmar montos.',
  runnerMaxLoadAmount: 'Tope de carga del runner',
  runnerMaxLoadHint: 'Monto máximo que un runner puede cargar al unir varias rutas de casas en una sola corrida (por defecto 1.000.000).',
  runnerMultiRouteTitle: 'Rutas autorizadas',
  runnerMultiRouteHint: 'Una ruta por casa. Puedes ejecutarlas por separado o como un solo viaje si no superas el tope.',
  runnerRunSeparate: 'Por separado',
  runnerRunMerged: 'Una corrida',
  runnerMergeOverCapacity: 'El total a recoger ({total}) supera el tope del runner ({max}). Ejecútalas por separado.',
  runnerMergedActive: 'Ejecutando {count} rutas de casas como un viaje · {total}',
  skipStop: 'Saltar parada',
  skipReason: 'Motivo',
  skipReasonPlaceholder: '¿Por qué saltar esta parada? (ej. listador no disponible)',
  skipRequest: 'Solicitar skip',
  skipRequestSent: 'Skip solicitado',
  skipRequestSentBody: '{name}: esperando autorización del banker.',
  skipRequestWaiting: 'Skip pendiente de autorización del banker',
  skipRequestFailed: 'No se pudo solicitar el skip.',
  skipRequestNeedsOnline: 'Solicitar skip requiere conexión.',
  skipRequestPending: 'Skip solicitado por el runner',
  skipApprove: 'Aprobar skip',
  skipReject: 'Rechazar skip',
  skipApproved: 'Skip aprobado',
  skipRejected: 'Skip rechazado',
  skipReviewFailed: 'No se pudo revisar la solicitud de skip.',
  skipStopFailed: 'No se pudo saltar la parada.',
  skipBankerAppliedBody: '{name} saltada. Se avisó al runner y se recalculó la ruta.',
  routeSelfCollectHint: 'No hay runners — inicia la ruta cuando quieras, navega como un runner y marca cada parada como recogida y asegurada.',
  routeSelfCollectLabel: 'Banker (auto-recogida)',
  routeSelfCollectAssignedBody: 'Ruta lista para auto-recogida. Iníciala cuando quieras empezar la ronda.',
  routeDepartAuthorizedSelfCollectBody: 'Ruta iniciada. Navega las paradas y marca cada una como recogida y asegurada al cobrar.',
  routeSelfCollectStart: 'Iniciar ruta',
  routeSelfCollectStarted: 'Ruta iniciada',
  routeSelfCollectStatusLabel: 'Cobro',
  routeSelfCollectStatusReady: 'Lista cuando quieras',
  routeSelfCollectStatusLive: 'En cobro — navega y asegura',
  routeSelfCollectStartHint: 'Sin runner. Inicia cuando te convenga; puedes abrir el mapa y navegar como un runner.',
  routeSelfCollectLiveHint: 'La ruta está en curso. Usa el mapa para navegar; la pantalla se mantiene encendida en navegación.',
  routeSelfCollectAutoSkipHint: 'Al iniciar, las paradas oficiales sin monto por recoger se saltan solas.',
  routeSelfCollectNavHint: 'La navegación in-app mantiene la pantalla encendida. El mapa en teléfono bloqueado requiere Mapas externos (Google/Apple).',
  secureCollect: 'Recogido y asegurado',
  secureCollectDone: 'Recogido y asegurado',
  secureCollectFailed: 'No se pudo marcar la parada como recogida y asegurada.',
  editStop: 'Editar parada',
  saveStop: 'Guardar',
  saveStopFailed: 'No se pudieron guardar los cambios de la parada.',
  stopAddr: 'Dirección',
  discrepancy: 'Discrepancia de monto',
  discrepancyDetail: 'Runner {runner} · Lister {lister}',
  discrepancyReviewed: 'Discrepancia revisada',
  discrepancyMarkReviewed: 'Marcar revisada',
  discrepancyReviewFailed: 'No se pudo marcar la discrepancia como revisada.',
  tabRoute: 'Ruta',
  tabHandoff: 'Entrega',
} as const;
